webpackJsonp([1],{

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BLACK = 'black';
var WHITE = 'white';

var oppositeColor = function oppositeColor(c) {
  return c === BLACK ? WHITE : BLACK;
};

exports.BLACK = BLACK;
exports.WHITE = WHITE;
exports.oppositeColor = oppositeColor;

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(239)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(415),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.play = exports.validatePlay = exports.freedoms = exports.neighboringPoints = undefined;

var _slicedToArray2 = __webpack_require__(197);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _isUndefined = __webpack_require__(388);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isEqual = __webpack_require__(387);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _filter = __webpack_require__(90);

var _filter2 = _interopRequireDefault(_filter);

var _flatMap = __webpack_require__(160);

var _flatMap2 = _interopRequireDefault(_flatMap);

var _map = __webpack_require__(162);

var _map2 = _interopRequireDefault(_map);

var _partition5 = __webpack_require__(381);

var _partition6 = _interopRequireDefault(_partition5);

var _differenceWith = __webpack_require__(377);

var _differenceWith2 = _interopRequireDefault(_differenceWith);

var _every = __webpack_require__(378);

var _every2 = _interopRequireDefault(_every);

var _uniqWith = __webpack_require__(383);

var _uniqWith2 = _interopRequireDefault(_uniqWith);

var _some = __webpack_require__(382);

var _some2 = _interopRequireDefault(_some);

var _flow = __webpack_require__(161);

var _flow2 = _interopRequireDefault(_flow);

var _arrays = __webpack_require__(96);

var _color = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function neighboringPoints(x, y, size) {
  var ret = [];

  if (x > 0) {
    ret.push({ x: x - 1, y: y });
  }

  if (x + 1 < size) {
    ret.push({ x: x + 1, y: y });
  }

  if (y > 0) {
    ret.push({ y: y - 1, x: x });
  }

  if (y + 1 < size) {
    ret.push({ y: y + 1, x: x });
  }

  return ret;
}

function moveIsSuicide(state, x, y, color) {
  var neighbors = neighboringPoints(x, y, state.size);

  var _partition = (0, _partition6.default)(function (p) {
    return state.board[p.y][p.x];
  })(neighbors),
      _partition2 = (0, _slicedToArray3.default)(_partition, 2),
      occupied = _partition2[0],
      free = _partition2[1];

  if (free.length > 0) {
    return false;
  }

  var _partition3 = (0, _partition6.default)(function (p) {
    return state.board[p.y][p.x] === color;
  })(occupied),
      _partition4 = (0, _slicedToArray3.default)(_partition3, 2),
      friends = _partition4[0],
      enemies = _partition4[1];

  free = (0, _flow2.default)((0, _flatMap2.default)(function (p) {
    return freedoms(state, p.x, p.y);
  }), (0, _uniqWith2.default)(_isEqual2.default))(friends);

  if (free.length > 1) {
    return false;
  }

  return !(0, _some2.default)(function (p) {
    return freedoms(state, p.x, p.y).length === 1;
  })(enemies);
}

function freedoms(state, x, y) {
  return findGroupAndFreedoms(state, x, y).freedoms;
}

function findGroupAndFreedoms(state, x, y) {
  var points = (0, _arrays.matrix)(state.size, state.size);

  var groupColor = state.board[y][x];

  if (!groupColor) {
    throw Error('No piece at ' + x + ',' + y);
  }

  calculateFreedoms(state, groupColor, x, y, points);

  var freedoms = [];
  var group = [];
  for (var i = 0; i < points.length; ++i) {
    var row = points[i];
    for (var j = 0; j < row.length; ++j) {
      if (row[j] === true) {
        freedoms.push({ x: j, y: i });
      } else if (row[j] === groupColor) {
        group.push({ x: j, y: i });
      }
    }
  }

  return { freedoms: freedoms, group: group };
}

function calculateFreedoms(state, color, x, y, calculated) {
  if (!(0, _isUndefined2.default)(calculated[y][x])) {
    return;
  }

  if (state.board[y][x] === color) {
    calculated[y][x] = color;
  } else {
    calculated[y][x] = (0, _isUndefined2.default)(state.board[y][x]);
  }

  var candidates = neighboringPoints(x, y, state.size);

  for (var i = 0; i < candidates.length; ++i) {
    var c = candidates[i];
    if ((0, _isUndefined2.default)(state.board[c.y][c.x])) {
      calculated[c.y][c.x] = true;
    } else if (state.board[c.y][c.x] === color) {
      calculateFreedoms(state, color, c.x, c.y, calculated);
    }
  }
}

function validatePlay(state, x, y) {
  if (state.board[y][x]) {
    return false;
  }

  if ((0, _isEqual2.default)(state.ko, { x: x, y: y })) {
    return false;
  }

  if (moveIsSuicide(state, x, y, state.current_turn)) {
    return false;
  }

  return true;
}

function play(state, x, y) {
  var changes = (0, _flow2.default)((0, _filter2.default)(function (p) {
    return state.board[p.y][p.x] === (0, _color.oppositeColor)(state.current_turn);
  }), (0, _map2.default)(function (p) {
    return findGroupAndFreedoms(state, p.x, p.y);
  }), (0, _filter2.default)(function (found) {
    return found.freedoms.length === 1;
  }), (0, _flatMap2.default)(function (found) {
    return found.group;
  }), (0, _uniqWith2.default)(_isEqual2.default))(neighboringPoints(x, y, state.size));

  var ko = null;

  if (changes.length === 1) {
    var isKo = (0, _flow2.default)((0, _differenceWith2.default)(_isEqual2.default)(neighboringPoints(x, y, state.size)), (0, _every2.default)(function (p) {
      return state.board[p.y][p.x] === (0, _color.oppositeColor)(state.current_turn);
    }))(changes);

    if (isKo) {
      ko = changes[0];
    }
  }

  changes.unshift({ x: x, y: y, color: state.current_turn });

  return { changes: changes, ko: ko };
}

exports.neighboringPoints = neighboringPoints;
exports.freedoms = freedoms;
exports.validatePlay = validatePlay;
exports.play = play;

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(55);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocalGame = function () {
  function LocalGame(store) {
    (0, _classCallCheck3.default)(this, LocalGame);

    this.store = store;
  }

  (0, _createClass3.default)(LocalGame, [{
    key: 'pass',
    value: function pass() {
      this.store.dispatch('pass');
    }
  }, {
    key: 'play',
    value: function play(location) {
      this.store.dispatch('playerTurn', location);
    }
  }, {
    key: 'localCurrentTurn',
    value: function localCurrentTurn() {
      return this.store.getters.currentTurn;
    }
  }]);
  return LocalGame;
}();

exports.default = LocalGame;

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getters = exports.mutations = exports.actions = exports.state = undefined;

var _promise = __webpack_require__(99);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(100);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(55);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _captures;

var _vue = __webpack_require__(54);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(29);

var _vuex2 = _interopRequireDefault(_vuex);

var _es6PromiseTry = __webpack_require__(68);

var _es6PromiseTry2 = _interopRequireDefault(_es6PromiseTry);

var _countBy = __webpack_require__(375);

var _countBy2 = _interopRequireDefault(_countBy);

var _flattenDeep = __webpack_require__(379);

var _flattenDeep2 = _interopRequireDefault(_flattenDeep);

var _filter = __webpack_require__(90);

var _filter2 = _interopRequireDefault(_filter);

var _defaults2 = __webpack_require__(376);

var _defaults3 = _interopRequireDefault(_defaults2);

var _flow = __webpack_require__(161);

var _flow2 = _interopRequireDefault(_flow);

var _arrays = __webpack_require__(96);

var _color = __webpack_require__(14);

var _engine = __webpack_require__(180);

var _remote_game = __webpack_require__(97);

var _remote_game2 = _interopRequireDefault(_remote_game);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

function inspectTerritory(state, x, y, t, territories) {
  if (territories[y][x]) {
    return;
  }

  var board = state.board,
      size = state.size;

  var color = board[y][x];
  if (color) {
    territories[y][x] = color;
    return;
  }

  territories[y][x] = t;

  var neighbors = (0, _engine.neighboringPoints)(x, y, size);

  for (var i = 0; i < neighbors.length; ++i) {
    var _neighbors$i = neighbors[i],
        nx = _neighbors$i.x,
        ny = _neighbors$i.y;


    if (board[ny][nx]) {
      t.neighbor(board[ny][nx]);
    }
    inspectTerritory(state, nx, ny, t, territories);
  }
}

var Territory = function () {
  function Territory(color) {
    (0, _classCallCheck3.default)(this, Territory);

    this.neighbors = [];
    if (color) {
      this.neighbor(color);
    }
  }

  (0, _createClass3.default)(Territory, [{
    key: 'neighbor',
    value: function neighbor(color) {
      if (this.neighbors[0] !== color) {
        this.neighbors.push(color);
      }
    }
  }, {
    key: 'owner',
    value: function owner() {
      if (this.neighbors.length === 1) {
        return this.neighbors[0];
      } else {
        return null;
      }
    }
  }]);
  return Territory;
}();

function territoryCounts(state) {
  var _defaults;

  var size = state.size;

  var territories = (0, _arrays.matrix)(size, size);
  for (var row = 0; row < size; ++row) {
    for (var col = 0; col < size; ++col) {
      if (territories[row][col]) {
        continue;
      }

      inspectTerritory(state, col, row, new Territory(), territories);
    }
  }

  return (0, _flow2.default)(_flattenDeep2.default, (0, _filter2.default)(function (t) {
    return t instanceof Territory;
  }), (0, _countBy2.default)(function (t) {
    return t.owner();
  }), (0, _defaults3.default)((_defaults = {}, (0, _defineProperty3.default)(_defaults, _color.BLACK, 0), (0, _defineProperty3.default)(_defaults, _color.WHITE, 0), _defaults)))(territories);
}

var state = exports.state = {
  online: true,
  game_done: false,
  board: (0, _arrays.matrix)(9, 9),
  gameType: 'placeholder',
  current_turn: null,
  remoteInviteId: null,
  remoteGameId: null,
  pass_last_turn: false,
  size: 9,
  captures: (_captures = {}, (0, _defineProperty3.default)(_captures, _color.BLACK, 0), (0, _defineProperty3.default)(_captures, _color.WHITE, 0), _captures),
  ko: null
};

var actions = exports.actions = {
  online: function online(_ref) {
    var commit = _ref.commit;
    return commit('online');
  },
  offline: function offline(_ref2) {
    var commit = _ref2.commit;
    return commit('offline');
  },

  newGame: function newGame(_ref3, _ref4) {
    var commit = _ref3.commit;
    var size = _ref4.size,
        remoteGame = _ref4.remoteGame;

    if (remoteGame) {
      return (0, _es6PromiseTry2.default)(function () {
        return _remote_game2.default.create({ size: size });
      }).then(function (g) {
        return commit('new_remote_game', g);
      });
    } else {
      return _promise2.default.resolve(commit('new_local_game', size));
    }
  },


  pass: function pass(_ref5) {
    var commit = _ref5.commit;
    return commit('pass_turn');
  },
  playerTurn: function playerTurn(_ref6, x, y) {
    var commit = _ref6.commit;
    return commit('player_turn', x, y);
  },

  joinGame: function joinGame(_ref7, _ref8) {
    var commit = _ref7.commit;
    var gameId = _ref8.gameId;

    return (0, _es6PromiseTry2.default)(function () {
      return _remote_game2.default.join({ gameId: gameId });
    }).then(function (g) {
      return commit('join_remote_game', g);
    });
  },
  remoteOpponentAccepted: function remoteOpponentAccepted(_ref9, _ref10) {
    var commit = _ref9.commit;
    var opponentId = _ref10.opponentId;

    commit('remote_opponent_accepted', { opponentId: opponentId });
  },
  cancelRemoteGame: function cancelRemoteGame(_ref11) {
    var commit = _ref11.commit;

    commit('cancel_remote_game');
  },
  addRemoteMove: function addRemoteMove(_ref12, _ref13) {
    var dispatch = _ref12.dispatch,
        commit = _ref12.commit;
    var id = _ref13.id,
        move = _ref13.move;
    var type = move.type,
        params = move.params;

    switch (type) {
      case 'play':
        var x = params.x,
            y = params.y;

        dispatch('playerTurn', { x: x, y: y });
        break;
      case 'pass':
        dispatch('pass');
        break;
    }

    commit('remote_move', { id: id });
  }
};

var mutations = exports.mutations = {
  online: function online(state) {
    state.online = true;
  },
  offline: function offline(state) {
    state.online = false;
  },
  new_local_game: function new_local_game(state, size) {
    state.gameType = 'local';
    state.game_done = false;
    state.size = size;
    state.board = (0, _arrays.matrix)(size, size);
    state.current_turn = _color.BLACK;
    state.captures[_color.BLACK] = 0;
    state.captures[_color.WHITE] = 0;
    state.ko = null;
    state.remoteGameId = null;
    state.pass_last_turn = false;
  },
  new_remote_game: function new_remote_game(state, _ref14) {
    var _state$captures;

    var size = _ref14.size,
        gameId = _ref14.gameId,
        inviteId = _ref14.inviteId,
        blackId = _ref14[_color.BLACK],
        whiteId = _ref14[_color.WHITE];

    state.gameType = 'remote';
    state.game_done = false;
    state.size = size;
    state.captures = (_state$captures = {}, (0, _defineProperty3.default)(_state$captures, _color.BLACK, 0), (0, _defineProperty3.default)(_state$captures, _color.WHITE, 0), _state$captures);
    state.board = (0, _arrays.matrix)(size, size);
    state.remoteGameId = gameId;
    state.remoteInviteId = inviteId;
    state.current_turn = _color.BLACK;
    _vue2.default.set(state, _color.BLACK, blackId);
    _vue2.default.set(state, _color.WHITE, whiteId);
  },
  cancel_remote_game: function cancel_remote_game(s) {
    s.gameType = 'placeholder';
    s.remoteGameId = null;
    s.remoteInviteId = null;
    s.current_turn = null;
    s.size = state.size;
    s.board = (0, _arrays.matrix)(s.size, s.size);
    _vue2.default.set(s, _color.BLACK, null);
    _vue2.default.set(s, _color.WHITE, null);
  },
  join_remote_game: function join_remote_game(state, _ref15) {
    var _state$captures2;

    var size = _ref15.size,
        gameId = _ref15.gameId,
        blackId = _ref15[_color.BLACK],
        whiteId = _ref15[_color.WHITE];

    state.gameType = 'remote';
    state.game_done = false;
    state.size = size;
    state.captures = (_state$captures2 = {}, (0, _defineProperty3.default)(_state$captures2, _color.BLACK, 0), (0, _defineProperty3.default)(_state$captures2, _color.WHITE, 0), _state$captures2);
    state.board = (0, _arrays.matrix)(size, size);
    state.remoteGameId = gameId;
    state.current_turn = _color.BLACK;
    _vue2.default.set(state, _color.BLACK, blackId);
    _vue2.default.set(state, _color.WHITE, whiteId);
  },
  remote_opponent_accepted: function remote_opponent_accepted(state, _ref16) {
    var opponentId = _ref16.opponentId;

    _vue2.default.set(state, _color.WHITE, opponentId);
  },
  remote_move: function remote_move(state, moveId) {
    state.lastRemoteMove = moveId;
  },
  player_turn: function player_turn(state, _ref17) {
    var x = _ref17.x,
        y = _ref17.y;

    if (!state.current_turn || !(0, _engine.validatePlay)(state, x, y)) {
      return;
    }

    var _play = (0, _engine.play)(state, x, y),
        turn = _play.changes,
        ko = _play.ko;

    for (var i = 0; i < turn.length; ++i) {
      var t = turn[i];
      _vue2.default.set(state.board[t.y], t.x, t.color);

      if (!t.color) {
        state.captures[state.current_turn]++;
      }
    }

    state.ko = ko;
    state.pass_last_turn = false;
    state.current_turn = (0, _color.oppositeColor)(state.current_turn);
  },
  pass_turn: function pass_turn(state) {
    state.ko = null;

    if (state.pass_last_turn) {
      state.current_turn = null;
      state.game_done = true;
    } else {
      state.current_turn = (0, _color.oppositeColor)(state.current_turn);
      state.pass_last_turn = true;
    }
  }
};

var getters = exports.getters = {
  online: function online(state) {
    return state.online;
  },
  ko: function ko(state) {
    return state.ko;
  },
  size: function size(state) {
    return state.size;
  },
  gameType: function gameType(state) {
    return state.gameType;
  },
  gameDone: function gameDone(state) {
    return state.game_done;
  },
  board: function board(state) {
    return state.board;
  },
  waitingForRemoteOpponent: function waitingForRemoteOpponent(state) {
    return state.gameType === 'remote' && !state[_color.WHITE];
  },
  inviteId: function inviteId(state) {
    return state.remoteInviteId;
  },
  captures: function captures(state) {
    return state.captures;
  },
  currentTurn: function currentTurn(state) {
    return state.current_turn;
  },

  score: function score(state) {
    var _ref18;

    var _state$captures3 = state.captures,
        blackCaptures = _state$captures3[_color.BLACK],
        whiteCaptures = _state$captures3[_color.WHITE];

    var _territoryCounts = territoryCounts(state),
        blackTerritory = _territoryCounts[_color.BLACK],
        whiteTerritory = _territoryCounts[_color.WHITE];

    return _ref18 = {}, (0, _defineProperty3.default)(_ref18, _color.BLACK, blackTerritory + blackCaptures), (0, _defineProperty3.default)(_ref18, _color.WHITE, whiteTerritory + whiteCaptures), _ref18;
  }
};

exports.default = new _vuex2.default.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(176);

__webpack_require__(177);

__webpack_require__(175);

__webpack_require__(178);

var _vue = __webpack_require__(54);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(179);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

new _vue2.default({
  el: '#app',
  components: { App: _App2.default },
  render: function render(h) {
    return h('app');
  }
});

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(54);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(29);

var _vuex2 = _interopRequireDefault(_vuex);

var _es6PromiseTry = __webpack_require__(68);

var _es6PromiseTry2 = _interopRequireDefault(_es6PromiseTry);

var _vueMdl = __webpack_require__(52);

var _Hello = __webpack_require__(406);

var _Hello2 = _interopRequireDefault(_Hello);

var _Board = __webpack_require__(407);

var _Board2 = _interopRequireDefault(_Board);

var _Captures = __webpack_require__(408);

var _Captures2 = _interopRequireDefault(_Captures);

var _NewGameDialog = __webpack_require__(413);

var _NewGameDialog2 = _interopRequireDefault(_NewGameDialog);

var _InviteOpponentDialog = __webpack_require__(410);

var _InviteOpponentDialog2 = _interopRequireDefault(_InviteOpponentDialog);

var _JoiningGameOverlay = __webpack_require__(411);

var _JoiningGameOverlay2 = _interopRequireDefault(_JoiningGameOverlay);

var _color = __webpack_require__(14);

var _store = __webpack_require__(182);

var _store2 = _interopRequireDefault(_store);

var _urijs = __webpack_require__(405);

var _urijs2 = _interopRequireDefault(_urijs);

var _local_game = __webpack_require__(181);

var _local_game2 = _interopRequireDefault(_local_game);

var _remote_game = __webpack_require__(97);

var _remote_game2 = _interopRequireDefault(_remote_game);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = {
  store: _store2.default,
  components: {
    Hello: _Hello2.default,
    Board: _Board2.default,
    Captures: _Captures2.default,
    NewGameDialog: _NewGameDialog2.default,
    InviteOpponentDialog: _InviteOpponentDialog2.default,
    JoiningGameOverlay: _JoiningGameOverlay2.default,
    MdlTooltip: _vueMdl.MdlTooltip,
    MdlButton: _vueMdl.MdlButton
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['gameType', 'ko', 'gameDone', 'score', 'board', 'size', 'waitingForRemoteOpponent']), {
    game: function game() {
      switch (this.gameType) {
        case 'local':
          return new _local_game2.default(this.$store);
        case 'remote':
          return new _remote_game2.default(this.$store);
        default:
          return null;
      }
    },
    localCurrentTurn: function localCurrentTurn() {
      return this.game ? this.game.localCurrentTurn() : null;
    },
    showNewGamePrompt: function showNewGamePrompt() {
      return !this.showJoiningDialog && (!this.game || this.gameDone);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    if (!navigator.onLine) {
      this.offline();
    }

    var uri = (0, _urijs2.default)(window.location.href);

    var _uri$query = uri.query(true),
        gameId = _uri$query.join;

    if (gameId) {
      this.showJoiningDialog = true;
      (0, _es6PromiseTry2.default)(function () {
        return _this.joinGame({ gameId: gameId });
      }).then(function () {
        _this.showJoiningDialog = false;
      });
    }
  },
  created: function created() {
    window.addEventListener('online', this.online);
    window.addEventListener('offline', this.offline);
  },
  destroyed: function destroyed() {
    window.removeEventListener('online', this.online);
    window.removeEventListener('offline', this.offline);
  },

  data: function data() {
    return {
      WHITE: _color.WHITE,
      BLACK: _color.BLACK,
      showNewGameDialog: false,
      showJoiningDialog: false
    };
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['newGame', 'joinGame', 'cancelRemoteGame', 'online', 'offline']), {
    pass: function pass() {
      this.game.pass();
    },
    play: function play(_ref) {
      var x = _ref.x,
          y = _ref.y;

      this.game.play({ x: x, y: y });
    },
    doNewGame: function doNewGame(options) {
      var _this2 = this;

      (0, _es6PromiseTry2.default)(function () {
        return _this2.newGame(options);
      }).then(function () {
        _this2.hideNewGamePrompt();
      });
    },
    promptNewGame: function promptNewGame() {
      this.showNewGameDialog = true;
    },
    hideNewGamePrompt: function hideNewGamePrompt() {
      this.showNewGameDialog = false;
    }
  })
};

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      msg: 'Hello World!'
    };
  }
};

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Stone = __webpack_require__(414);

var _Stone2 = _interopRequireDefault(_Stone);

var _Grid = __webpack_require__(409);

var _Grid2 = _interopRequireDefault(_Grid);

var _KoMarker = __webpack_require__(412);

var _KoMarker2 = _interopRequireDefault(_KoMarker);

var _graphics = __webpack_require__(30);

var _map = __webpack_require__(162);

var _map2 = _interopRequireDefault(_map);

var _mapValues = __webpack_require__(380);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _flatMap = __webpack_require__(160);

var _flatMap2 = _interopRequireDefault(_flatMap);

var _filter = __webpack_require__(90);

var _filter2 = _interopRequireDefault(_filter);

var _range = __webpack_require__(163);

var _range2 = _interopRequireDefault(_range);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var range0 = (0, _range2.default)(0);
var compact = (0, _filter2.default)(Boolean);

exports.default = {
  props: {
    localCurrentTurn: String,
    ko: Object,
    size: Number,
    board: Array
  },
  data: function data() {
    return {
      hover: null
    };
  },

  computed: {
    cellSize: function cellSize() {
      return _graphics.SCALE;
    },
    viewBox: function viewBox() {
      return '0 0 ' + this.size * _graphics.SCALE + ' ' + this.size * _graphics.SCALE;
    },
    stones: function stones() {
      var _this = this;

      var ret = compact((0, _flatMap2.default)(function (y) {
        return (0, _map2.default)(function (x) {
          var color = _this.board[y][x];
          if (!color) {
            return null;
          }

          var stone = {
            x: x,
            y: y,
            color: color
          };

          return stone;
        })(range0(_this.size));
      })(range0(this.size)));

      return ret;
    }
  },
  components: {
    Stone: _Stone2.default,
    Grid: _Grid2.default,
    KoMarker: _KoMarker2.default
  },
  methods: {
    mouseMove: function mouseMove(event) {
      if (!this.localCurrentTurn) {
        return;
      }

      var p = this.eventToPoint(event);
      this.hover = this.isValidPoint(p) ? { x: p.x, y: p.y, color: this.localCurrentTurn } : null;
    },
    mouseLeave: function mouseLeave() {
      this.hover = null;
    },
    click: function click(event) {
      var p = this.eventToPoint(event);

      if (!this.isValidPoint(p)) {
        return;
      }

      this.$emit('play', { x: p.x, y: p.y });
    },
    isValidPoint: function isValidPoint(p) {
      var x = p.x,
          y = p.y;

      return x >= 0 && y >= 0 && x < this.size && y < this.size;
    },

    pointToCoordinate: function pointToCoordinate(x) {
      var cs = this.cellSize;
      return x * cs + cs / 2.0;
    },
    coordinateToPoint: function coordinateToPoint(x) {
      return Math.round((x - this.cellSize / 2) / this.cellSize);
    },
    eventToPoint: function eventToPoint(event) {
      var _this2 = this;

      var point = this.$el.createSVGPoint();
      point.x = event.clientX;
      point.y = event.clientY;

      var ctm = this.$refs.board.getScreenCTM();

      var _point$matrixTransfor = point.matrixTransform(ctm.inverse()),
          x = _point$matrixTransfor.x,
          y = _point$matrixTransfor.y;

      return (0, _mapValues2.default)(function (a) {
        return _this2.coordinateToPoint(a);
      })({ x: x, y: y });
    }
  }
};

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(29);

var _color = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['captures']), {
    black: function black() {
      return this.captures[_color.BLACK];
    },
    white: function white() {
      return this.captures[_color.WHITE];
    }
  })
};

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _range = __webpack_require__(163);

var _range2 = _interopRequireDefault(_range);

var _graphics = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GUIDE_DOTS = {
  19: [{ x: 3, y: 3 }, { x: 9, y: 3 }, { x: 15, y: 3 }, { x: 3, y: 9 }, { x: 9, y: 9 }, { x: 15, y: 9 }, { x: 3, y: 15 }, { x: 9, y: 15 }, { x: 15, y: 15 }],
  13: [{ x: 3, y: 3 }, { x: 9, y: 3 }, { x: 3, y: 9 }, { x: 9, y: 9 }, { x: 6, y: 6 }],
  9: [{ x: 2, y: 2 }, { x: 6, y: 2 }, { x: 2, y: 6 }, { x: 6, y: 6 }, { x: 4, y: 4 }]
};

exports.default = {
  props: ['size'],
  methods: {
    pointToCoordinate: function pointToCoordinate(x) {
      var cs = this.cellSize;
      return x * cs + cs / 2.0;
    }
  },
  computed: {
    cellSize: function cellSize() {
      return _graphics.SCALE;
    },
    guides: function guides() {
      return GUIDE_DOTS[this.size];
    },
    centers: function centers() {
      return (0, _range2.default)(0)(this.size);
    }
  }
};

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(29);

var _dialogPolyfill = __webpack_require__(114);

var _dialogPolyfill2 = _interopRequireDefault(_dialogPolyfill);

var _vueMdl = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MdlTextfield: _vueMdl.MdlTextfield,
    MdlButton: _vueMdl.MdlButton,
    MdlTooltip: _vueMdl.MdlTooltip,
    MdlProgress: _vueMdl.MdlProgress
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['inviteId']), {
    invitationUrl: function invitationUrl() {
      return window.location.origin + ('/?join=' + this.inviteId);
    }
  }),
  methods: {
    copyInvite: function copyInvite() {
      this.$refs.inviteUrl.$el.querySelector('input').select();
      document.execCommand('copy');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  },
  mounted: function mounted() {
    if (!this.$refs.inviteOpponent.showModal) {
      _dialogPolyfill2.default.registerDialog(this.$refs.inviteOpponent);
    }
    this.$refs.inviteOpponent.showModal();
  }
};

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMdl = __webpack_require__(52);

exports.default = {
  components: {
    MdlSpinner: _vueMdl.MdlSpinner
  }
};

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _graphics = __webpack_require__(30);

exports.default = {
  props: ['x', 'y'],
  computed: {
    topLeft: function topLeft() {
      return { x: this.x - _graphics.SCALE / 4, y: this.y - _graphics.SCALE / 4 };
    },
    topRight: function topRight() {
      return { x: this.x + _graphics.SCALE / 4, y: this.y - _graphics.SCALE / 4 };
    },
    bottomLeft: function bottomLeft() {
      return { x: this.x - _graphics.SCALE / 4, y: this.y + _graphics.SCALE / 4 };
    },
    bottomRight: function bottomRight() {
      return { x: this.x + _graphics.SCALE / 4, y: this.y + _graphics.SCALE / 4 };
    }
  }
};

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _dialogPolyfill = __webpack_require__(114);

var _dialogPolyfill2 = _interopRequireDefault(_dialogPolyfill);

var _vueMdl = __webpack_require__(52);

var _vuex = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizes = [9, 13, 19];

exports.default = {
  components: {
    MdlSwitch: _vueMdl.MdlSwitch,
    MdlButton: _vueMdl.MdlButton
  },
  directives: {
    MdlRippleEffect: _vueMdl.MdlRippleEffect
  },
  data: function data() {
    return {
      sizes: sizes,
      size: null,
      remoteGame: false
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['online'])),
  methods: {
    doNewGame: function doNewGame() {
      this.$emit('new-game', { size: this.size, remoteGame: this.remoteGame });
    },
    close: function close() {
      this.$emit('cancel');
    }
  },
  mounted: function mounted() {
    if (!this.$refs.newGame.showModal) {
      _dialogPolyfill2.default.registerDialog(this.$refs.newGame);
    }
    componentHandler.upgradeElement(this.$refs.size);
    this.$refs.newGame.showModal();
  }
};

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = __webpack_require__(14);

var _graphics = __webpack_require__(30);

exports.default = {
  props: ['x', 'y', 'color'],
  computed: {
    isBlack: function isBlack() {
      return this.color === _color.BLACK;
    },
    isWhite: function isWhite() {
      return this.color === _color.WHITE;
    },
    size: function size() {
      return _graphics.SCALE / 2;
    }
  }
};

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var SCALE = 20;

exports.SCALE = SCALE;

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(421),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(245)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  "data-v-7ac1a4c3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(246)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(423),
  /* scopeId */
  "data-v-7e70cda0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(424),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(243)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  "data-v-44ea09be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(240)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(416),
  /* scopeId */
  "data-v-216717d9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(244)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(420),
  /* scopeId */
  "data-v-6138641e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(241)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(417),
  /* scopeId */
  "data-v-3105c712",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(242)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(418),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 415:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "app-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', [_c('captures')], 1), _vm._v(" "), (_vm.showJoiningDialog) ? _c('joining-game-overlay') : _vm._e(), _vm._v(" "), (_vm.showNewGamePrompt) ? _c('div', {
    staticClass: "app-prompt-overlay"
  }, [_c('div', [_c('div', {
    staticClass: "app-prompt"
  }, [(_vm.gameDone) ? _c('div', [_c('h5', [_vm._v("Game Complete!")]), _vm._v(" "), _c('ul', {
    staticClass: "app-game-scores"
  }, [_c('li', [_vm._v("Black: " + _vm._s(_vm.score[_vm.BLACK]))]), _vm._v(" "), _c('li', [_vm._v("White: " + _vm._s(_vm.score[_vm.WHITE]))])])]) : _c('div', [_c('h5', [_vm._v("Welcome to VueGo")])]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-js-ripple-effect",
    attrs: {
      "colored": "",
      "raised": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.promptNewGame($event)
      }
    }
  }, [_vm._v("\n              New Game\n            ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('board', {
    attrs: {
      "local-current-turn": _vm.localCurrentTurn,
      "ko": _vm.ko,
      "size": _vm.size,
      "board": _vm.board
    },
    on: {
      "play": _vm.play
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "app-actions"
  }, [(_vm.localCurrentTurn) ? _c('div', [_c('mdl-button', {
    staticClass: "mdl-js-ripple-effect",
    attrs: {
      "id": "pass",
      "fab": "",
      "icon": "",
      "colored": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.pass($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("skip_next")])]), _vm._v(" "), _c('mdl-tooltip', {
    attrs: {
      "target": "pass"
    }
  }, [_vm._v("\n        Pass Turn\n      ")])], 1) : _vm._e()]), _vm._v(" "), (_vm.showNewGameDialog) ? _c('new-game-dialog', {
    on: {
      "new-game": _vm.doNewGame,
      "cancel": _vm.hideNewGamePrompt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.waitingForRemoteOpponent) ? _c('invite-opponent-dialog', {
    on: {
      "cancel": _vm.cancelRemoteGame
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', [_c('div', {
    staticClass: "overlay-container"
  }, [_c('mdl-spinner'), _vm._v(" "), _c('h6', [_vm._v("Joining Game")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog', {
    ref: "newGame",
    staticClass: "mdl-dialog",
    on: {
      "close": _vm.close
    }
  }, [_c('h6', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v("New Game")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_c('div', {
    ref: "size",
    staticClass: "mdl-selectfield mdl-js-selectfield mdl-selectfield--floating-label"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.size),
      expression: "size"
    }],
    staticClass: "mdl-selectfield__select",
    attrs: {
      "id": "game-size"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.size = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sizes), function(s) {
    return _c('option', {
      domProps: {
        "value": s
      }
    }, [_vm._v(_vm._s(s))])
  })), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "game-size"
    }
  }, [_vm._v("Game Size")])]), _vm._v(" "), (_vm.online) ? _c('mdl-switch', {
    attrs: {
      "id": "play-online"
    },
    model: {
      value: (_vm.remoteGame),
      callback: function($$v) {
        _vm.remoteGame = $$v
      },
      expression: "remoteGame"
    }
  }, [_vm._v("Play Online")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__actions"
  }, [_c('mdl-button', {
    directives: [{
      name: "mdl-ripple-effect",
      rawName: "v-mdl-ripple-effect"
    }],
    attrs: {
      "disabled": !_vm.size
    },
    nativeOn: {
      "click": function($event) {
        _vm.doNewGame($event)
      }
    }
  }, [_vm._v("New Game")]), _vm._v(" "), _c('mdl-button', {
    directives: [{
      name: "mdl-ripple-effect",
      rawName: "v-mdl-ripple-effect"
    }],
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('circle', {
    class: {
      'white-stone': _vm.isWhite, 'black-stone': _vm.isBlack
    },
    attrs: {
      "r": _vm.size,
      "cx": _vm.x,
      "cy": _vm.y
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog', {
    ref: "inviteOpponent",
    staticClass: "mdl-dialog"
  }, [_c('h6', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v("Invite Player")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_c('div', {
    staticClass: "invite-url-container"
  }, [_c('mdl-textfield', {
    ref: "inviteUrl",
    attrs: {
      "value": _vm.invitationUrl,
      "readonly": ""
    }
  }), _vm._v(" "), _c('mdl-tooltip', {
    attrs: {
      "target": "copy_invite"
    }
  }, [_vm._v("Copy Invite URL")]), _vm._v(" "), _c('mdl-button', {
    attrs: {
      "id": "copy_invite",
      "icon": "content_copy"
    },
    nativeOn: {
      "click": function($event) {
        _vm.copyInvite($event)
      }
    }
  })], 1), _vm._v(" "), _c('mdl-progress', {
    attrs: {
      "indeterminate": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__actions"
  }, [_c('mdl-button', {
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('line', {
    staticClass: "ko-marker",
    attrs: {
      "x1": _vm.topLeft.x,
      "x2": _vm.topRight.x,
      "y1": _vm.topLeft.y,
      "y2": _vm.topRight.y
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "ko-marker",
    attrs: {
      "x1": _vm.topLeft.x,
      "x2": _vm.bottomLeft.x,
      "y1": _vm.topLeft.y,
      "y2": _vm.bottomLeft.y
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "ko-marker",
    attrs: {
      "x1": _vm.topRight.x,
      "x2": _vm.topRight.x,
      "y1": _vm.topRight.y,
      "y2": _vm.bottomRight.y
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "ko-marker",
    attrs: {
      "x1": _vm.bottomLeft.x,
      "x2": _vm.bottomRight.x,
      "y1": _vm.bottomLeft.y,
      "y2": _vm.bottomRight.y
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    ref: "board",
    staticClass: "board",
    class: {
      'hover': _vm.hover
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": _vm.viewBox,
      "preserveAspectRatio": "xMidYMid meet"
    },
    on: {
      "mousemove": _vm.mouseMove,
      "mouseleave": _vm.mouseLeave,
      "!click": function($event) {
        _vm.click($event)
      }
    }
  }, [_c('grid', {
    attrs: {
      "size": _vm.size
    }
  }), _vm._v(" "), _c('g', _vm._l((_vm.stones), function(s) {
    return _c('stone', {
      key: "'' + s.x + s.y",
      attrs: {
        "x": _vm.pointToCoordinate(s.x),
        "y": _vm.pointToCoordinate(s.y),
        "color": s.color
      }
    })
  })), _vm._v(" "), (_vm.hover) ? _c('g', [_c('stone', {
    staticClass: "hover-stone",
    attrs: {
      "x": _vm.pointToCoordinate(_vm.hover.x),
      "y": _vm.pointToCoordinate(_vm.hover.y),
      "color": _vm.hover.color
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ko) ? _c('g', [_c('ko-marker', {
    attrs: {
      "x": _vm.pointToCoordinate(_vm.ko.x),
      "y": _vm.pointToCoordinate(_vm.ko.y)
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "captures"
  }, [_c('li', [_vm._v("Black: " + _vm._s(_vm.black))]), _vm._v(" "), _c('li', [_vm._v("White: " + _vm._s(_vm.white))])])
},staticRenderFns: []}

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_vm._l((_vm.centers), function(x) {
    return _c('line', {
      attrs: {
        "x1": _vm.pointToCoordinate(x),
        "x2": _vm.pointToCoordinate(x),
        "y1": _vm.pointToCoordinate(0),
        "y2": _vm.pointToCoordinate(_vm.size - 1),
        "stroke": "black",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.centers), function(y) {
    return _c('line', {
      attrs: {
        "y1": _vm.pointToCoordinate(y),
        "y2": _vm.pointToCoordinate(y),
        "x1": _vm.pointToCoordinate(0),
        "x2": _vm.pointToCoordinate(_vm.size - 1),
        "stroke": "black",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.guides), function(dot) {
    return _c('circle', {
      attrs: {
        "cx": _vm.pointToCoordinate(dot.x),
        "cy": _vm.pointToCoordinate(dot.y),
        "r": "3"
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matrix = matrix;
function matrix(colCount, rowCount, initial) {
  var columns = [];

  for (var i = 0; i < colCount; ++i) {
    var rows = [];
    for (var j = 0; j < rowCount; ++j) {
      rows[j] = initial;
    }

    columns[i] = rows;
  }

  return columns;
}

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(99);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(100);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(55);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _es6PromiseTry = __webpack_require__(68);

var _es6PromiseTry2 = _interopRequireDefault(_es6PromiseTry);

var _firebase = __webpack_require__(249);

var _firebase2 = _interopRequireDefault(_firebase);

var _color = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_firebase2.default.initializeApp({
  apiKey: 'AIzaSyD1sB2mtSubsImIEh4SklU7EivMnJHKLDA',
  authDomain: 'vuego.firebaseapp.com',
  databaseURL: 'https://vuego.firebaseio.com',
  storageBucket: 'project-1396985000601130379.appspot.com'
});

var fb = _firebase2.default.database();

var RemoteGame = function () {
  function RemoteGame(store) {
    (0, _classCallCheck3.default)(this, RemoteGame);

    this.store = store;
    var gameId = store.state.remoteGameId;

    if (!store.state[_color.WHITE]) {
      var opponent = fb.ref('games/' + gameId + '/' + _color.WHITE);
      var cb = function cb(snapshot) {
        if (!snapshot.val()) {
          return;
        }

        store.dispatch('remoteOpponentAccepted', { opponentId: snapshot.val() });
        opponent.off('value', cb);
      };
      opponent.on('value', cb);
    }

    this.movesRef = fb.ref('moves').child(gameId);
    this.movesRef.on('child_added', function (m) {
      store.dispatch('addRemoteMove', { id: m.key, move: m.val() });
    });
  }

  (0, _createClass3.default)(RemoteGame, [{
    key: 'pass',
    value: function pass() {
      this.movesRef.push({
        type: 'pass'
      });
    }
  }, {
    key: 'play',
    value: function play(_ref) {
      var x = _ref.x,
          y = _ref.y;

      this.movesRef.push({
        type: 'play',
        params: {
          x: x,
          y: y
        }
      });
    }
  }, {
    key: 'localCurrentTurn',
    value: function localCurrentTurn() {
      var t = this.store.getters.currentTurn;

      if (!t) {
        return t;
      }

      var uid = _firebase2.default.auth().currentUser.uid;

      return this.store.state[t] === uid ? t : null;
    }
  }]);
  return RemoteGame;
}();

RemoteGame.create = function (_ref2) {
  var _games$push;

  var size = _ref2.size;

  if (!_firebase2.default.auth().currentUser) {
    return (0, _es6PromiseTry2.default)(function () {
      return _firebase2.default.auth().signInAnonymously();
    }).then(function () {
      return RemoteGame.create({ size: size });
    });
  }

  var uid = _firebase2.default.auth().currentUser.uid;
  var games = fb.ref('games');
  var newGame = games.push((_games$push = {
    size: size
  }, (0, _defineProperty3.default)(_games$push, _color.BLACK, uid), (0, _defineProperty3.default)(_games$push, _color.WHITE, null), _games$push));

  var key = newGame.key;

  return _promise2.default.resolve((0, _defineProperty3.default)({ size: size, gameId: key, inviteId: key }, _color.BLACK, uid));
};

RemoteGame.join = function (_ref3) {
  var gameId = _ref3.gameId;

  if (!_firebase2.default.auth().currentUser) {
    return (0, _es6PromiseTry2.default)(function () {
      return _firebase2.default.auth().signInAnonymously();
    }).then(function () {
      return RemoteGame.join({ gameId: gameId });
    });
  }

  var game = fb.ref('games/' + gameId);
  return (0, _es6PromiseTry2.default)(function () {
    return game.update((0, _defineProperty3.default)({}, _color.WHITE, _firebase2.default.auth().currentUser.uid));
  }).then(function () {
    return game.once('value');
  }).then(function (v) {
    var _ref4;

    var _v$val = v.val(),
        size = _v$val.size,
        white = _v$val[_color.WHITE],
        black = _v$val[_color.BLACK];

    return _ref4 = { size: size }, (0, _defineProperty3.default)(_ref4, _color.WHITE, white), (0, _defineProperty3.default)(_ref4, _color.BLACK, black), (0, _defineProperty3.default)(_ref4, 'gameId', v.key), _ref4;
  });
};

exports.default = RemoteGame;

/***/ })

},[183]);


// WEBPACK FOOTER //
// static/js/app.924912ce6c83316086fd.js